import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import brzTheme from '@brz/brz-global-mui-theme';
import { LocalizationProvider } from '@localization/LocalizationProvider';
import { Provider } from 'react-redux';
import { PermissionProvider } from '@auth/PermissionProvider';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from '@commonComponents/core/ErrorFallback';
import { ReportImagesComponent, ReportImagesComponentProps } from './ReportImagesComponent';
import { useInjectReducers } from '@hooks/useInjectReducers';
import { DynamicStore } from '@state/interfaces/idynamic-store';

/**
 * Wrapper component for ReportImagesComponent
 * Provides necessary context providers and error boundaries
 * @param props - ReportImagesComponentProps
 */
export const ReportImagesComponentWrapper: React.FC<Readonly<ReportImagesComponentProps>> = ({ organizationId, store }) => {
  const reducerInjected = useInjectReducers(store as DynamicStore, organizationId);
  if (!reducerInjected) {
    return null;
  }

  return (
    <ThemeProvider theme={brzTheme}>
      <LocalizationProvider>
        <Provider store={store as DynamicStore}>
          <PermissionProvider>
            <ErrorBoundary FallbackComponent={ErrorFallback}>
              <ReportImagesComponent organizationId={organizationId} store={store} />
            </ErrorBoundary>
          </PermissionProvider>
        </Provider>
      </LocalizationProvider>
    </ThemeProvider>
  );
};
